export const ELEVENLABS_VOICES = [
  { value: 'JBFqnCBsd6RMkjVDRZzb', label: 'George' },
  { value: 'EXAVITQu4vr4xnSDxMaL', label: 'Sarah' },
  { value: '21m00Tcm4TlvDq8ikWAM', label: 'Rachel' },
  { value: 'pNInz6obpgDQGcFmaJgB', label: 'Adam' },
  { value: 'nPczCjzI2devNBz1zQrb', label: 'Brian' },
  { value: 'XB0fDUnXU5powFXDhCwa', label: 'Charlotte' },
  { value: 'onwK4e9ZLuTAKqWW03F9', label: 'Daniel' },
];

export const OPENAI_VOICES = [
  { value: 'nova',    label: 'Nova' },
  { value: 'alloy',   label: 'Alloy' },
  { value: 'echo',    label: 'Echo' },
  { value: 'fable',   label: 'Fable' },
  { value: 'onyx',    label: 'Onyx' },
  { value: 'shimmer', label: 'Shimmer' },
];

export const ELEVENLABS_DEFAULT_VOICE = ELEVENLABS_VOICES[0].value; // George
export const OPENAI_DEFAULT_VOICE     = OPENAI_VOICES[0].value;     // Nova
